'use client';

import { IGroupInfo } from '@/api/types/product';
import FaqPart from './FaqPart';
import RelatedBlockLink from './RelatedBlockLink';

interface GoodsListSeoBlockProps {
  groupInfo: IGroupInfo;
  isWeb: boolean;
  noMoreShow: boolean;
  showBottomRelatedLink: boolean;
  sdProductListPageRelatedGroupClick: (item: any, index: number, position: string) => void;
  sdProductListPageRelatedGroupExp: (item: any, index: number, position: string) => void;
}

export default function GoodsListSeoBlock({
  groupInfo,
  isWeb,
  noMoreShow,
  showBottomRelatedLink,
  sdProductListPageRelatedGroupClick,
  sdProductListPageRelatedGroupExp,
}: GoodsListSeoBlockProps) {
  return (
    <>
      {showBottomRelatedLink && (
        <div
          className={`text-center ${
            isWeb ? 'mt-[56px] pt-40 border-t border-solid border-[#eeeeee]' : ''
          }`}
        >
          {groupInfo?.related_block_link && groupInfo?.related_block_link?.length > 0 && (
            <div className={`seo-block-link ${isWeb ? 'mb-40' : 'px-[14px]'}`}>
              <div className={`flex flex-wrap ${isWeb ? 'gap-20' : 'gap-12'}`}>
                {groupInfo?.related_block_link?.map((item: any, index: number) => (
                  <RelatedBlockLink
                    key={item.id}
                    item={item}
                    index={index}
                    trackProductListPageRelatedGroupClick={(
                      _item: any,
                      _index: number,
                      _position: string,
                    ) => {
                      sdProductListPageRelatedGroupClick(_item, _index, _position);
                    }}
                    trackProductListPageRelatedGroupExp={sdProductListPageRelatedGroupExp}
                    isWeb={isWeb}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      )}

      {groupInfo?.h_one && noMoreShow && !isWeb && <FaqPart groupInfo={groupInfo} />}
    </>
  );
}
